import styled from 'styled-components';

export const Content = styled.div`
  flex: 1;
`;

export const CloseWrapper = styled.div`
  cursor: pointer;
  height: 10px;
  width: 10px;
  margin-left: auto;
  margin-right: 1em;
`;

export const BannerWrapper = styled.div`
  transition: height 300ms ease-in-out;
  height: ${props => props.height}px;
  font-size: 16px;
  overflow: hidden;

  &.is-dismissed {
    height: 0px;
  }
`;
